import dayjs from 'dayjs';

export function timeDifferenceDescription(timestamp: number) {
  const now = dayjs();
  const inputTime = dayjs(timestamp);

  if (now.isSame(inputTime, 'day')) {
    // 如果是今天
    return '今天';
  } else if (now.subtract(1, 'day').isSame(inputTime, 'day')) {
    // 如果是昨天
    return '昨天';
  } else if (now.diff(inputTime, 'day') <= 7) {
    // 如果在7天内
    return '7天内';
  } else if (now.diff(inputTime, 'day') <= 30) {
    // 如果在30天内
    return '30天内';
  } else {
    // 超过30天的情况
    return '一个月前';
  }
}
